import { useEffect, useState } from "react";
import useUser from "../../../../customHooks/useUser";
import { apiClientEosNative } from "../../../../apiClient";
import { getDeviceId, getGuid, notify, unitedApiCheck } from "../../../../utils";
import { useRecoilState, useSetRecoilState } from "recoil";
import { unitedRegistrationState, unitedScannerIdState } from "../../../../globals/atoms";

export default function useUnitedRoleRegister () {
    const { user } = useUser();
    const [registered, setRegistered] = useRecoilState(unitedRegistrationState);
    const [scannerId, setScannerId] = useRecoilState(unitedScannerIdState);

    useEffect(() => {
        const register = async () => {
            const scannerId = getDeviceId();
            try {
                await apiClientEosNative.post(`/user/united-role-register`, {
                    userId: user.additionalData.unitedVNumber,
                    scannerId,
                    firstName: user.s_first_name,
                    lastName: user.s_last_name
                });  
                setRegistered(true);
                setScannerId(scannerId);
                notify('United Role registration complete');
            } catch (err) {
                alert(`United Role register error: ${JSON.stringify(err)}`);
            }
        }
        if (!registered && unitedApiCheck(user)) {
            register();
        }
    }, [user]);

    return {
        ready: registered && Boolean(scannerId)
    }
}